// Initialize the Intersection Observer to handle scroll animations
export const initScrollAnimations = () => {
  // First, remove any existing 'visible' classes to reset animations
  const animatedVisibleElements = document.querySelectorAll('.animate-on-scroll.visible');
  animatedVisibleElements.forEach((element) => {
    element.classList.remove('visible');
  });
  
  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  
  if (!animatedElements.length) return;
  
  // Create observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // Stop observing once animated
      }
    });
  }, {
    threshold: 0.15, // Element is considered visible when 15% is in viewport
    rootMargin: '0px'
  });
  
  // Observe all animated elements
  animatedElements.forEach((element) => {
    observer.observe(element);
  });
  
  return observer;
}; 